import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  padding: 20px;

  .btn.disabled,
  .btn:disabled,
  fieldset:disabled .btn {
    cursor: not-allowed !important;
    pointer-events: auto !important;
  }

  .parceiroContainer input:disabled {
    cursor: not-allowed !important;
  }

  .ButtonLoja .form-check-input:disabled {
    cursor: not-allowed !important;
  }
`;

export const BtnContainer = styled.div`
  .btn-quitacao {
    background-color: #57069e;
    border-color: #29004c;
    width: 100px;
    &:focus {
      box-shadow: 0 0 0 0.25rem #c2a0f8;
    }
  }
`;
